import { createApp } 		from "vue";
import VueLazyLoad 			from 'vue-lazyload';

import App 					from "./App.vue";
import router 				from "./router";
import store 				from "./store";
import globalComponents 	from "./global-components";
import PrimeVue from 'primevue/config';

import fEs 					from "./assets/locales/es.json";
import fEn 					from "./assets/locales/en.json";
import { createI18n } 		from "vue-i18n";
import "./libs";

import "./assets/sass/app.scss";
import './assets/vueform-slider.css';
import "./assets/stylesheets/rp-classes.css";
import "./assets/stylesheets/rp-colors.css";
import "./assets/stylesheets/rp-elements.css";
import 'primevue/resources/themes/lara-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';

const messages = { es: fEs, en: fEn };
const i18n = new createI18n({
	legacy: false,
	locale: 'en',
	fallbackLocale: 'en',
	messages
});

const app = createApp(App)
	.use(store)
	.use(router)
	.use(PrimeVue)
	.use(VueLazyLoad)

app.config.isCustomElement = tag => tag.startsWith('smart-');

app.directive('focus', {
	mounted(el) {
		el.focus()
	}
})

globalComponents(app);

app.use(i18n);
app.mount("#app");